import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { Button } from './ui/button';

const ServiceAreaSection = () => {
  return (
    <section className="py-20 md:py-28 bg-slate-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-slate-600 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-slate-600 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] border border-slate-600 rounded-full"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Icon */}
        <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <MapPin className="w-10 h-10 text-amber-400" />
        </div>

        <span className="inline-block text-amber-400 font-semibold text-sm uppercase tracking-wider mb-3">
          Service Area
        </span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          Proudly Serving South Perth & Greater Perth Metro
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
          DC Lock and Key provides professional locksmith services throughout South Perth and the surrounding Perth metropolitan area. No matter where you are, we're just a call away.
        </p>

        <a href={businessInfo.phoneLink}>
          <Button size="lg" className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold gap-2 px-8">
            <Phone className="w-5 h-5" />
            Call {businessInfo.phone}
          </Button>
        </a>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
